/// amarildo lacerda
import { Component, OnInit,Input, Output,EventEmitter , forwardRef  } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  selector: 'mat-data-navigation',
  template: `
  <div>
  <span class="pull-right">
      <button mat-icon-button (click)="addClick(this)"  color="primary">
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
        </button>
          <button *ngIf="editing" mat-icon-button color="primary" (click)="postClick(this)">
      <i class="fa fa-cloud-upload" aria-hidden="true"></i>
    </button>
  </span>
</div>
`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MatDataNavigationComponent),
      multi: true
    }
  ]

})

export class  MatDataNavigationComponent  implements ControlValueAccessor {
  
  propagateChange;

  @Output()
  add = new EventEmitter();
  @Output()
  post = new EventEmitter();
  @Input()
  editing :boolean = false;

  postClick(x){
    this.post.emit(x);
  }
  addClick(x){
    this.add.emit(x);
  }
  writeValue(obj: any): void {
    if (obj !== undefined) {
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.registerOnTouched = fn;
  };
  
}
